import { EnvQuestionValue } from '@/domain/impact-env/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

export const getImpactEnvResponses = createAppAsyncThunk(
  'impactEnv/getImpactEnvResponses',
  async (
    params: Params,
    { extra: { impactEnvGateway, snackbarGateway } },
  ): Promise<EnvQuestionValue[]> => {
    try {
      const responses = await impactEnvGateway.getImpactEnvResponses(
        params.projectId,
      );
      return responses;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('Error.server-exchange-error'));
}
